module.exports = __webpack_public_path__ + "img/friendly-resort.b08b91db.jpg";